/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React, { useState, useEffect } from 'react';
import { getPromotionInfoAsync, IDiscountInfo } from '../../actions/product-services';
import { IHeiPromotionViewProps } from './hei-promotion';
import InnerHTML from 'dangerously-set-html-content';

const HeiPromotionView = (props: IHeiPromotionViewProps) => {
    const { promotionId, config } = props;
    const [promotionInfo, setPromotionInfo] = useState<IDiscountInfo>();

    useEffect(() => {
        let isMounted = true;
        void getPromotionInfoAsync({ callerContext: props.context.actionContext }, promotionId).then(d => {
            if (isMounted) {
                if (d.Expired) {
                    location.assign(config.expiredPage ?? '/offer-expired');
                } else {
                    setPromotionInfo(d);
                }
            }
        });

        return () => {
            isMounted = false;
        };
    }, [promotionId]);

    if (!promotionInfo) {
        return null;
    }

    return (
        <div className='hei-promo row'>
            <h2 className='hei-promo-header'>{promotionInfo.MarketingName}</h2>
            {promotionInfo.MarketingHtml && (
                <div className='hei-promo-body'>
                    <InnerHTML html={promotionInfo.MarketingHtml} />
                </div>
            )}
        </div>
    );
};

export default HeiPromotionView;
